module.exports = __webpack_public_path__ + "edc278e951ad80e8c93c55bbdd4fa651.png";